module.exports = __webpack_public_path__ + "img/0-27.902cd42a.jpg";